const Y = 600.0;
const SINGLE_X = 358.0;
const DUAL_X = 358.0 * 2;

export const PLATE_MEASUREMENTS = {
  SINGLE_X,
  DUAL_X,
  Y,
};
